export default {
  condition: "表示条件",
  referenceDate: "基準日",
  compareDate: "比較対象日",
  startDate: "開始日付",
  endDate: "終了日付",
  targetStore: "対象店舗",
  targetClassification: "対象分類",
  storeCode: "店舗",
  majorCategory: "大分類",
  middleCategory: "中分類",
  displayItem: "表示項目",
  btnSave: "保存",
  apply: "適用",
  orderQuantity: "発注数量",
  orderAmount: "発注金額",
  salesAmount: "販売",
  cancelAmount: "廃棄",
  dataGraph: "データグラフ",
  dataTable: "データ表",
  revenueInPercent: "昨対",
  middleClassificationReport: "Middle Classification Report",
};
